"use client";

import { useGameStore } from "@/stores/game-store";
import { useUIStore } from "@/stores/ui-store";
import { Button } from "@/components/ui/button";
import { X, Plus, UserPlus, Wrench, Activity } from "lucide-react";

export function SectionPanel() {
  const currentSectionId = useGameStore((s) => s.currentSectionId);
  const sections = useGameStore((s) => s.sections);
  const surggies = useGameStore((s) => s.surggies);
  const setActivePanel = useUIStore((s) => s.setActivePanel);

  const section = sections.find((s) => s.id === currentSectionId);

  return (
    <div className="absolute top-0 left-0 bottom-0 w-80 z-50 bg-[#f5ecd6] border-r-2 border-[#1a1a1a] flex flex-col animate-slide-in-left shadow-[2px_0_0_#5c4a30]">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b-2 border-[#1a1a1a]">
        <span className="text-[#1a1a1a] font-mono text-sm font-bold uppercase tracking-wider">
          {section?.name ?? "Section"}
        </span>
        <button
          onClick={() => setActivePanel(null)}
          className="p-1 rounded hover:bg-[#b89968]/40 text-[#5c4a30] hover:text-[#1a1a1a] transition-colors cursor-pointer"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-6 scrollbar-thin">
        {/* Section Info */}
        <div>
          <div className="flex items-center gap-2 mb-2">
            <Wrench className="w-4 h-4 text-[#c54a4a]" />
            <span className="text-[#5c4a30] font-mono text-xs uppercase tracking-wider">
              Type
            </span>
          </div>
          <p className="text-[#1a1a1a] font-mono text-sm">
            {section?.type ?? "Unknown"}
          </p>
        </div>

        {/* Connected Tools */}
        <div>
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <Wrench className="w-4 h-4 text-[#3d6890]" />
              <span className="text-[#5c4a30] font-mono text-xs uppercase tracking-wider">
                Connected Tools
              </span>
            </div>
          </div>
          <div className="space-y-2">
            <div className="p-2 rounded border border-[#1a1a1a] bg-[#fff7e6] flex items-center gap-2">
              <div className="w-6 h-6 rounded bg-[#6a9bc4] border border-[#1a1a1a]" />
              <span className="text-[#5c4a30] font-mono text-xs">
                No tools connected
              </span>
            </div>
          </div>
          <Button variant="ghost" size="sm" className="mt-2 w-full">
            <Plus className="w-3 h-3 mr-1" /> Add Tool
          </Button>
        </div>

        {/* Assigned Surggies */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <UserPlus className="w-4 h-4 text-[#c54a4a]" />
            <span className="text-[#5c4a30] font-mono text-xs uppercase tracking-wider">
              Assigned Surggies
            </span>
          </div>
          <div className="space-y-2">
            {surggies.length === 0 ? (
              <p className="text-[#8a7a5c] font-mono text-xs">
                No Surggies assigned
              </p>
            ) : (
              surggies.slice(0, 3).map((s) => (
                <div
                  key={s.id}
                  className="p-2 rounded border border-[#1a1a1a] bg-[#fff7e6] flex items-center gap-2"
                >
                  <div
                    className="w-6 h-6 rounded border border-[#1a1a1a]"
                    style={{
                      backgroundColor:
                        s.team === "surge"
                          ? "#c54a4a"
                          : s.team === "pulse"
                          ? "#6a9bc4"
                          : "#7a9a4a",
                    }}
                  />
                  <div>
                    <span className="text-[#1a1a1a] font-mono text-xs block">
                      {s.name}
                    </span>
                    <span className="text-[#8a7a5c] font-mono text-[10px]">
                      {s.status}
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>
          <Button variant="ghost" size="sm" className="mt-2 w-full">
            <UserPlus className="w-3 h-3 mr-1" /> Assign Surggie
          </Button>
        </div>

        {/* Recent Activity */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Activity className="w-4 h-4 text-[#5c7935]" />
            <span className="text-[#5c4a30] font-mono text-xs uppercase tracking-wider">
              Recent Activity
            </span>
          </div>
          <div className="space-y-2">
            <p className="text-[#8a7a5c] font-mono text-xs italic">
              No recent activity
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
